/* NANS · OFON, le code du jeu. Les images sont dans nans-ofon-media.js. */
var OFON_SB = { url: 'https://dqswdrzvhxnmaueqgzca.supabase.co', key: 'sb_publishable_RAJhX1CpWbkEolzI6Eqsiw_UCEp4btq' };
(function () {
  var canvas = document.getElementById('game');
  if (!canvas || canvas.dataset.ready) return;
  canvas.dataset.ready = '1';
  var g = canvas.getContext('2d');
  var stageEl = document.getElementById('ofonStage');
  if (window.OFON_MEDIA) document.getElementById('ofonCover').src = window.OFON_MEDIA.cover;
  var W = 360, H = 640, dpr = 1;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function resize() {
    var r = canvas.getBoundingClientRect();
    dpr = Math.min(2, window.devicePixelRatio || 1);
    H = Math.round(W * r.height / r.width) || 640;
    canvas.width = W * dpr; canvas.height = H * dpr;
  }
  window.addEventListener('resize', resize); resize();

  var $ = function (id) { return document.getElementById(id); };
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ================= Textures générées une fois ================= */
  function mkCanvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }

  // bruit doux qui se répète sans couture
  function makeNoise(size, cells, octaves, tint) {
    var c = mkCanvas(size, size), x = c.getContext('2d'), img = x.createImageData(size, size), d = img.data;
    var grids = [];
    for (var o = 0; o < octaves; o++) {
      var n = cells * Math.pow(2, o), gr = [];
      for (var i = 0; i < n * n; i++) gr.push(Math.random());
      grids.push({ n: n, gr: gr });
    }
    function sm(t) { return t * t * (3 - 2 * t); }
    for (var py = 0; py < size; py++) for (var px = 0; px < size; px++) {
      var v = 0, amp = 1, tot = 0;
      for (var k = 0; k < grids.length; k++) {
        var G = grids[k], fx = px / size * G.n, fy = py / size * G.n, ix = Math.floor(fx), iy = Math.floor(fy), tx = sm(fx - ix), ty = sm(fy - iy);
        var a = G.gr[(iy % G.n) * G.n + ix % G.n], b = G.gr[(iy % G.n) * G.n + (ix + 1) % G.n];
        var cc = G.gr[((iy + 1) % G.n) * G.n + ix % G.n], dd = G.gr[((iy + 1) % G.n) * G.n + (ix + 1) % G.n];
        v += (a + (b - a) * tx + (cc - a) * ty + (a - b - cc + dd) * tx * ty) * amp; tot += amp; amp *= 0.5;
      }
      v /= tot;
      var p = (py * size + px) * 4;
      d[p] = tint[0] * v; d[p + 1] = tint[1] * v; d[p + 2] = tint[2] * v; d[p + 3] = 255;
    }
    x.putImageData(img, 0, 0);
    return c;
  }

  // caustiques : réseau de lignes lumineuses comme la lumière au fond de l'eau
  function makeCaustics(size, n) {
    var c = mkCanvas(size, size), x = c.getContext('2d'), img = x.createImageData(size, size), d = img.data, pts = [];
    for (var i = 0; i < n; i++) pts.push([Math.random() * size, Math.random() * size]);
    for (var py = 0; py < size; py++) for (var px = 0; px < size; px++) {
      var d1 = 1e9, d2 = 1e9;
      for (var j = 0; j < n; j++) {
        var dx = Math.abs(px - pts[j][0]), dy = Math.abs(py - pts[j][1]);
        if (dx > size / 2) dx = size - dx; if (dy > size / 2) dy = size - dy;
        var dist = dx * dx + dy * dy;
        if (dist < d1) { d2 = d1; d1 = dist; } else if (dist < d2) d2 = dist;
      }
      var e = Math.sqrt(d2) - Math.sqrt(d1), v = Math.pow(Math.max(0, 1 - e / 7), 3);
      var p = (py * size + px) * 4;
      d[p] = 200; d[p + 1] = 245; d[p + 2] = 255; d[p + 3] = v * 255;
    }
    x.putImageData(img, 0, 0);
    return c;
  }

  function makeGrain(size) {
    var c = mkCanvas(size, size), x = c.getContext('2d'), img = x.createImageData(size, size), d = img.data;
    for (var i = 0; i < d.length; i += 4) { var v = Math.random() * 255; d[i] = d[i + 1] = d[i + 2] = v; d[i + 3] = 255; }
    x.putImageData(img, 0, 0);
    return c;
  }

  var TEX = {};
  function buildTextures(done) {
    setTimeout(function () {
      TEX.noise = makeNoise(160, 4, 4, [255, 255, 255]);
      TEX.stone = makeNoise(96, 6, 3, [255, 255, 255]);
      setTimeout(function () {
        TEX.caustics = makeCaustics(reduce ? 128 : 176, 22);
        TEX.grain = makeGrain(128);
        TEX.pNoise = g.createPattern(TEX.noise, 'repeat');
        TEX.pStone = g.createPattern(TEX.stone, 'repeat');
        TEX.pCaus = g.createPattern(TEX.caustics, 'repeat');
        TEX.pGrain = g.createPattern(TEX.grain, 'repeat');
        loadPhotos(function () { buildSprites(); done(); loadAccount(); });
      }, 30);
    }, 30);
  }

  /* ================= Son ================= */
  var A = { ctx: null, on: true };
  function audioInit() {
    if (A.ctx) { if (A.ctx.state === 'suspended') A.ctx.resume(); return; }
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (navigator.audioSession) { try { navigator.audioSession.type = 'playback'; } catch (e) {} }
    var ctx = A.ctx = new AC();
    A.master = ctx.createGain(); A.master.gain.value = A.on ? 0.9 : 0;
    A.muffle = ctx.createBiquadFilter(); A.muffle.type = 'lowpass'; A.muffle.frequency.value = 18000;
    A.muffle.connect(A.master); A.master.connect(ctx.destination);
    // eau : bruit brun filtré, avec une houle lente
    var len = ctx.sampleRate * 3, buf = ctx.createBuffer(1, len, ctx.sampleRate), data = buf.getChannelData(0), lastV = 0;
    for (var i = 0; i < len; i++) { var white = Math.random() * 2 - 1; lastV = (lastV + 0.02 * white) / 1.02; data[i] = lastV * 3.2; }
    var src = ctx.createBufferSource(); src.buffer = buf; src.loop = true;
    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 700;
    var wg = ctx.createGain(); wg.gain.value = 0.35;
    var lfo = ctx.createOscillator(), lfoG = ctx.createGain(); lfo.frequency.value = 0.12; lfoG.gain.value = 0.15;
    lfo.connect(lfoG); lfoG.connect(wg.gain); lfo.start();
    src.connect(lp); lp.connect(wg); wg.connect(A.muffle); src.start();
    // nappe grave
    var pad = ctx.createOscillator(), pad2 = ctx.createOscillator(), pg = ctx.createGain();
    pad.type = 'sine'; pad.frequency.value = 55; pad2.type = 'sine'; pad2.frequency.value = 82.4; pg.gain.value = 0.05;
    pad.connect(pg); pad2.connect(pg); pg.connect(A.muffle); pad.start(); pad2.start();
    A.noiseBuf = buf;
  }
  function sfxSplash(strength) {
    if (!A.ctx || !A.on) return;
    var ctx = A.ctx, t = ctx.currentTime, s = ctx.createBufferSource(); s.buffer = A.noiseBuf;
    var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 900; bp.Q.value = 0.8;
    var gg = ctx.createGain(); gg.gain.setValueAtTime(0.0001, t); gg.gain.exponentialRampToValueAtTime(0.9 * strength, t + 0.02); gg.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    s.connect(bp); bp.connect(gg); gg.connect(A.master); s.start(t, Math.random() * 2, 0.6);
  }
  function sfxPing(f) {
    if (!A.ctx || !A.on) return;
    var ctx = A.ctx, t = ctx.currentTime, o = ctx.createOscillator(), gg = ctx.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(f, t); o.frequency.exponentialRampToValueAtTime(f * 1.5, t + 0.12);
    gg.gain.setValueAtTime(0.0001, t); gg.gain.exponentialRampToValueAtTime(0.12, t + 0.01); gg.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
    o.connect(gg); gg.connect(A.muffle); o.start(t); o.stop(t + 0.4);
  }
  function muffle(sec, floor) {
    if (!A.ctx) return;
    var t = A.ctx.currentTime, f = A.muffle.frequency;
    f.cancelScheduledValues(t); f.setValueAtTime(f.value, t); f.exponentialRampToValueAtTime(floor || 380, t + 0.06);
    if (sec > 0) f.exponentialRampToValueAtTime(18000, t + sec);
  }
  function fadeOut(sec) { if (!A.ctx) return; var t = A.ctx.currentTime; A.master.gain.cancelScheduledValues(t); A.master.gain.setValueAtTime(A.master.gain.value, t); A.master.gain.linearRampToValueAtTime(0, t + sec); }
  function fadeIn() { if (!A.ctx) return; var t = A.ctx.currentTime; A.master.gain.cancelScheduledValues(t); A.master.gain.setValueAtTime(0, t); A.master.gain.linearRampToValueAtTime(A.on ? 0.9 : 0, t + 0.8); A.muffle.frequency.cancelScheduledValues(t); A.muffle.frequency.setValueAtTime(18000, t); }
  $('mute').addEventListener('click', function () {
    A.on = !A.on; this.textContent = A.on ? 'SON ON' : 'SON OFF'; this.setAttribute('aria-pressed', A.on ? 'false' : 'true');
    if (A.ctx) A.master.gain.value = A.on ? 0.9 : 0;
  });

  /* ================= Boutique ================= */
  var OUTFITS = {
    cover: { name: 'Maillot OFON', photo: 'cover', price: 0, sleeve: ['#FAD24A', '#B97F12'], body: ['#FCD650', '#E6AE24', '#C3880F'], panel: '#EEECE5', chevron: '#141414', band: '#141414', bandRed: '#C0281E', short: false, hood: false, print: '' },
    noir: { name: 'Maillot noir', photo: 'noir', price: 300, sleeve: ['#3A3A3A', '#101010'], body: ['#3C3C3C', '#222222', '#111111'], panel: '', chevron: '', band: '#FF5B1F', bandRed: '', short: false, hood: true, print: 'NANS' },
    blanc: { name: 'Maillot blanc', photo: 'blanc', price: 200, sleeve: ['#FFFFFF', '#CFCAC0'], body: ['#FFFFFF', '#EEEAE2', '#CFC9BE'], panel: '', chevron: '', band: '', bandRed: '#FF5B1F', short: true, hood: false, print: '' },
    kaniar: { name: 'Édition KANIAR', photo: 'orange', price: -1, url: '/products/nans-kaniar', sleeve: ['#2A2A2A', '#0C0C0C'], body: ['#2C2C2C', '#1A1A1A', '#0C0C0C'], panel: '', chevron: '', band: '', bandRed: '', short: true, hood: false, print: 'KANIAR' }
  };
  var TRAILS = {
    none: { name: 'Aucune', price: 0 },
    bulles: { name: 'Bulles dorées', price: 150 },
    braises: { name: 'Braises', price: 150 }
  };
  var PHOTO_SRC = (window.OFON_MEDIA && window.OFON_MEDIA.photos) || {};
  var PHOTO = {};
  function loadPhotos(done) {
    var keys = Object.keys(PHOTO_SRC), left = keys.length;
    keys.forEach(function (k) {
      var im = new Image();
      im.onload = im.onerror = function () { if (--left === 0) done(); };
      im.src = PHOTO_SRC[k]; PHOTO[k] = im;
    });
  }
  var SAVE = { wallet: 100, owned: { cover: 1, none: 1 }, outfit: 'cover', trail: 'none' };
  try { var raw = localStorage.getItem('nansOfonSave'); if (raw) SAVE = Object.assign(SAVE, JSON.parse(raw)); } catch (e) {}
  var ACCOUNT = { on: false, pseudo: null }, syncTimer = null;
  function pushSave() {
    if (!ACCOUNT.on) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/apps/nans/sauvegarde', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ donnees: SAVE }) }).catch(function () {});
    }, 600);
  }
  function persist() { try { localStorage.setItem('nansOfonSave', JSON.stringify(SAVE)); } catch (e) {} pushSave(); }
  function renderAccount() {
    var el = document.getElementById('ofonAccount');
    if (!el) return;
    if (!ACCOUNT.on) { el.innerHTML = 'Joue en invité, ou <a href="/account/login?return_url=' + encodeURIComponent(location.pathname) + '">connecte-toi</a> pour garder tes étincelles, tes tenues et tes records sur tous tes appareils.'; return; }
    el.innerHTML = ACCOUNT.pseudo ? 'Connecté : <b>@' + ACCOUNT.pseudo.replace(/[<>&]/g, '') + '</b> · <a href="/pages/joueur">ma vitrine</a>' : 'Connecté · <a href="/pages/joueur">choisis ton pseudo</a> pour apparaître dans les classements.';
  }
  function loadAccount() {
    fetch('/apps/nans/moi', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (m) {
        if (!m || !m.connecte) { renderAccount(); return; }
        ACCOUNT.on = true; ACCOUNT.pseudo = m.pseudo;
        var srv = m.sauvegarde;
        if (srv && typeof srv === 'object') {
          var owned = Object.assign({}, srv.owned || {}, SAVE.owned || {});
          SAVE = Object.assign({}, SAVE, srv);
          SAVE.owned = owned;
          SAVE.wallet = Math.max(Number(srv.wallet) || 0, Number(SAVE.wallet) || 0);
        }
        var rec = (m.records || []).filter(function (r) { return r.jeu === 'ofon'; })[0];
        if (rec && rec.score > best) { best = rec.score; try { localStorage.setItem('nansOfonReal', String(best)); } catch (e) {} $('best').textContent = best; }
        persist(); renderWallet(); renderAccount();
        if (SPR && OUTFITS[SAVE.outfit]) buildSprites();
      }).catch(function () { renderAccount(); });
  }
  function renderWallet() { document.querySelectorAll('.js-wallet').forEach(function (el) { el.textContent = SAVE.wallet; }); }

  /* ================= Jeu ================= */
  var best = 0;
  try { best = parseInt(localStorage.getItem('nansOfonReal') || '0', 10) || 0; } catch (e) {}
  $('best').textContent = best;

  var ZONES = [
    { m: 0, name: 'La surface' }, { m: 300, name: 'Les remous' }, { m: 800, name: 'Le courant' },
    { m: 1500, name: 'Les tourbillons' }, { m: 2400, name: 'OFON' }
  ];

  var P, obs, items, fx, texts, ripples, specks, flows, dist, travel, speed, lives, shield, sparks, nears, combo, comboT, running = false, sinking = 0, sinkTarget, time, last, keys = {}, nextSpawn, nextFlow, zoneIdx, zoneTimer, hintTimer, shake;
  var joy = { on: false, id: null, bx: 0, by: 0, x: 0, y: 0 };
  function diff() { return Math.min(1, dist / 3000); }

  function reset() {
    P = { x: W / 2, y: H * 0.64, vx: 0, vy: 0, inv: 0, rot: 0 };
    seedDeep();
    obs = []; items = []; fx = []; texts = []; ripples = []; flows = [];
    specks = [];
    for (var i = 0; i < 40; i++) specks.push({ x: rnd(0, W), y: rnd(0, H), s: rnd(0.3, 1.2), a: rnd(0, 6) });
    dist = 0; travel = 0; speed = 2.3; lives = 3; shield = 0; sparks = 0; nears = 0; combo = 0; comboT = 0;
    time = 0; nextSpawn = 120; nextFlow = 900; zoneIdx = 0; zoneTimer = 0; hintTimer = 240; sinking = 0; shake = 0; sinkTarget = null;
    $('hint').classList.remove('is-off');
    renderLives();
  }
  function renderLives() { var l = Math.max(0, lives); $('lives').textContent = '●●●'.slice(0, l) + '○○○'.slice(0, 3 - l); $('shield').textContent = shield ? '◯' : ''; }

  function spawn() {
    var d = diff(), r = Math.random();
    if (r < 0.33) obs.push({ kind: 'rock', x: rnd(28, W - 28), y: -50, r: rnd(18, 30 + d * 14), seed: Math.random() * 10, rot: rnd(0, 6) });
    else if (r < 0.56) obs.push({ kind: 'log', x: rnd(40, W - 40), y: -70, len: rnd(70, 110 + d * 40), rot: rnd(-1.2, 1.2), vr: rnd(-0.006, 0.006), seed: Math.random() * 10 });
    else if (r < 0.75 && dist > 200) obs.push({ kind: 'pool', x: rnd(60, W - 60), y: -90, r: rnd(46, 64 + d * 24), ph: 0 });
    else if (r < 0.88) obs.push({ kind: 'shoal', x: rnd(20, W - 20), y: -60, n: Math.floor(rnd(7, 13)), dir: Math.random() < 0.5 ? -1 : 1, ph: rnd(0, 6) });
    else obs.push({ kind: 'rock', x: rnd(28, W - 28), y: -50, r: rnd(18, 28), seed: Math.random() * 10, rot: rnd(0, 6) });
    if (Math.random() < 0.09 && !shield) items.push({ kind: 'air', x: rnd(40, W - 40), y: -160, ph: 0 });
    var n = Math.random() < 0.65 ? Math.floor(rnd(2, 5)) : 0, sx = rnd(40, W - 40), curve = rnd(-18, 18);
    for (var i = 0; i < n; i++) items.push({ kind: 'spark', x: clamp(sx + curve * i, 20, W - 20), y: -110 - i * 34, ph: rnd(0, 6) });
    nextSpawn = rnd(120, 190) - d * 55;
  }

  function damage() {
    if (P.inv > 0 || sinking) return;
    if (shield) {
      shield = 0; renderLives(); P.inv = 50;
      for (var s = 0; s < 14; s++) fx.push({ kind: 'drop', x: P.x + Math.cos(s) * 40, y: P.y + Math.sin(s) * 40, vx: Math.cos(s) * 2, vy: Math.sin(s) * 2, life: 1 });
      sfxSplash(0.6); texts.push({ x: P.x, y: P.y - 50, txt: 'BULLE ÉCLATÉE', life: 1 });
      return;
    }
    lives--; renderLives(); P.inv = 90; shake = 14; combo = 0; comboT = 0;
    if (navigator.vibrate) { try { navigator.vibrate(80); } catch (e) {} }
    for (var i = 0; i < 3; i++) ripples.push({ x: P.x, y: P.y, r: 10 + i * 8, life: 1, c: 1 });
    for (var j = 0; j < 22; j++) { var a = rnd(0, 6.28), sp = rnd(1.5, 4.5); fx.push({ kind: 'drop', x: P.x + Math.cos(a) * 20, y: P.y + Math.sin(a) * 20, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1 }); }
    sfxSplash(1); muffle(0.9);
    if (lives <= 0) startSink(null, 'TU AS COULÉ');
  }

  function startSink(pool, cause) {
    if (sinking) return;
    sinking = 1; sinkTarget = pool; $('cause').textContent = cause;
    if (navigator.vibrate) { try { navigator.vibrate([60, 40, 180]); } catch (e) {} }
    muffle(0, 160); fadeOut(2);
  }

  function update(dt) {
    time += dt;
    if (!sinking && Math.random() < 0.035 * dt) ripples.push({ x: P.x + rnd(-6, 6), y: P.y + rnd(-6, 6), r: 16, life: 1 });
    ripples.forEach(function (r) { r.r += 0.8 * dt; r.y += speed * 0.55 * dt; r.life -= 0.011 * dt; });
    ripples = ripples.filter(function (r) { return r.life > 0; });
    specks.forEach(function (s) { s.y += (speed * 0.8 + s.s * 0.3) * dt; s.a += 0.05 * dt; if (s.y > H + 6) { s.y = -6; s.x = rnd(0, W); } });

    if (sinking) {
      sinking += dt;
      if (sinkTarget) { P.x += (sinkTarget.x - P.x) * 0.06 * dt; P.y += (sinkTarget.y - P.y) * 0.06 * dt; P.rot += 0.09 * dt; }
      else P.rot += 0.015 * dt;
      if (!reduce && Math.random() < 0.6) fx.push({ kind: 'bub', x: P.x + rnd(-16, 16), y: P.y + rnd(-18, 18), life: 1, r: rnd(1.5, 4) });
      fx.forEach(function (p) { p.life -= 0.022 * dt; if (p.r) p.r += 0.05 * dt; });
      fx = fx.filter(function (p) { return p.life > 0; });
      if (sinking > 130) gameOver();
      return;
    }

    var d = diff();
    speed = 2.3 + d * 3.6;
    travel += speed * dt;
    dist += speed * dt / 6;
    if (comboT > 0) { comboT -= dt; if (comboT <= 0) combo = 0; }
    if (hintTimer > 0) { hintTimer -= dt; if (hintTimer <= 0) $('hint').classList.add('is-off'); }
    if (P.inv > 0) P.inv -= dt;
    if (shake > 0) shake -= dt;

    var ax = 0, ay = 0;
    if (joy.on) {
      var dx = joy.x - joy.bx, dy = joy.y - joy.by, len = Math.hypot(dx, dy);
      if (len > 4) { var mag = Math.min(1, len / 48); ax = dx / len * mag; ay = dy / len * mag; }
    }
    ax += (keys.ArrowRight || keys.d ? 1 : 0) - (keys.ArrowLeft || keys.q || keys.a ? 1 : 0);
    ay += (keys.ArrowDown || keys.s ? 1 : 0) - (keys.ArrowUp || keys.z || keys.w ? 1 : 0);
    P.vx += ax * 0.38 * dt; P.vy += ay * 0.3 * dt;
    if ((ax || ay) && !reduce && Math.random() < 0.18 * dt) ripples.push({ x: P.x - ax * 30, y: P.y - ay * 30 + 30, r: 6, life: 0.8 });

    // courants latéraux
    nextFlow -= speed * dt;
    if (nextFlow <= 0 && dist > 500) { flows.push({ y: -120, h: rnd(90, 150), dir: Math.random() < 0.5 ? -1 : 1, f: rnd(0.12, 0.2 + d * 0.12) }); nextFlow = rnd(700, 1300); }
    flows.forEach(function (fl) { fl.y += speed * dt; if (P.y > fl.y && P.y < fl.y + fl.h) P.vx += fl.dir * fl.f * dt; });
    flows = flows.filter(function (fl) { return fl.y < H + 20; });

    // tourbillons : aspiration en spirale
    obs.forEach(function (o) {
      if (o.kind !== 'pool') return;
      var ddx = o.x - P.x, ddy = o.y - P.y, dd = Math.hypot(ddx, ddy) || 1, reach = o.r * 2.1;
      if (dd < reach) {
        var f = Math.pow(1 - dd / reach, 1.4) * 0.5;
        P.vx += (ddx / dd * f + (-ddy / dd) * f * 0.7) * dt;
        P.vy += (ddy / dd * f + (ddx / dd) * f * 0.7) * dt;
      }
      if (dd < o.r * 0.36) startSink(o, 'AVALÉ PAR UN TOURBILLON');
    });

    P.vx *= Math.pow(0.9, dt); P.vy *= Math.pow(0.9, dt);
    P.x = clamp(P.x + P.vx * dt, 26, W - 26);
    P.y = clamp(P.y + P.vy * dt, H * 0.36, H * 0.86);
    P.rot += ((P.vx * 0.05) - P.rot) * 0.08 * dt;

    nextSpawn -= speed * dt;
    if (nextSpawn <= 0) spawn();

    obs.forEach(function (o) {
      o.y += speed * dt;
      if (o.kind === 'log') o.rot += o.vr * dt;
      if (o.kind === 'pool') o.ph += 0.04 * dt;
      if (o.kind === 'shoal') { o.ph += 0.05 * dt; o.x += o.dir * 0.45 * dt; }
      if (o.kind !== 'rock' && o.kind !== 'log') return;
      var gap;
      if (o.kind === 'rock') gap = Math.hypot(P.x - o.x, P.y - o.y) - (o.r + 14);
      else {
        var cs = Math.cos(o.rot), sn = Math.sin(o.rot), rx = P.x - o.x, ry = P.y - o.y;
        var lx = rx * cs + ry * sn, ly = -rx * sn + ry * cs;
        gap = Math.max(Math.abs(lx) - (o.len / 2 + 10), Math.abs(ly) - 21);
      }
      if (!o.hit && gap < 0) { o.hit = true; damage(); }
      else if (!o.hit && gap < 12) o.close = true;
      if (o.close && !o.hit && !o.near && o.y > P.y + 30) {
        o.near = true; nears++; dist += 6;
        texts.push({ x: P.x, y: P.y - 46, txt: 'FRÔLÉ +6 M', life: 1 }); sfxPing(520);
      }
    });
    obs = obs.filter(function (o) { return o.y < H + 160; });

    items.forEach(function (it) {
      it.y += speed * dt; it.ph += 0.1 * dt;
      if (it.done) return;
      var hitR = it.kind === 'air' ? 30 : 26;
      if (Math.hypot(P.x - it.x, P.y - it.y) < hitR) {
        it.done = true;
        if (it.kind === 'air') { shield = 1; renderLives(); texts.push({ x: it.x, y: it.y - 16, txt: 'BULLE D\'AIR', life: 1 }); sfxPing(660); sfxPing(990); }
        else {
          sparks++;
          combo = comboT > 0 ? Math.min(5, combo + 1) : 1; comboT = 150;
          var pts = 4 * combo; dist += pts;
          texts.push({ x: it.x, y: it.y - 12, txt: '+' + pts + ' M', life: 1 });
          for (var i = 0; i < 8; i++) fx.push({ kind: 'ember', x: it.x, y: it.y, vx: rnd(-2, 2), vy: rnd(-2, 2), life: 1 });
          sfxPing(880 + combo * 120);
        }
        if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
      }
    });
    items = items.filter(function (it) { return !it.done && it.y < H + 30; });

    fx.forEach(function (p) {
      if (p.kind === 'gold') { p.x += p.vx * dt; p.y += p.vy * dt + speed * 0.4 * dt; p.life -= 0.02 * dt; }
      else if (p.kind === 'ember' || p.kind === 'drop') { p.x += p.vx * dt; p.y += p.vy * dt + speed * 0.5 * dt; p.vx *= 0.96; p.vy *= 0.96; p.life -= 0.035 * dt; }
      else p.life -= 0.03 * dt;
    });
    fx = fx.filter(function (p) { return p.life > 0; });
    texts.forEach(function (t) { t.y -= 0.6 * dt; t.life -= 0.022 * dt; });
    texts = texts.filter(function (t) { return t.life > 0; });

    var dm = Math.floor(dist);
    for (var z = ZONES.length - 1; z >= 0; z--) {
      if (dm >= ZONES[z].m) { if (z > zoneIdx) { zoneIdx = z; showZone(z); } break; }
    }
    if (zoneTimer > 0) { zoneTimer -= dt; if (zoneTimer <= 0) $('zone').classList.remove('is-on'); }

    $('score').textContent = dm;
    $('sparks').textContent = sparks;
    $('combo').textContent = combo > 1 ? ' ×' + combo : '';
  }

  function showZone(z) {
    $('zoneSub').textContent = ZONES[z].m + ' M';
    $('zoneName').textContent = ZONES[z].name;
    $('zone').classList.add('is-on'); zoneTimer = 140;
  }

  /* ================= Rendu ================= */
  function tile(pattern, ox, oy, scale, alpha, op) {
    var tw = pattern === TEX.pNoise ? TEX.noise.width : pattern === TEX.pCaus ? TEX.caustics.width : pattern === TEX.pGrain ? TEX.grain.width : 128;
    g.save();
    g.globalAlpha = alpha; g.globalCompositeOperation = op || 'source-over';
    g.scale(scale, scale);
    g.translate(-(((ox / scale) % tw) + tw) % tw, -(((oy / scale) % tw) + tw) % tw);
    g.fillStyle = pattern; g.fillRect(0, 0, W / scale + tw * 2, H / scale + tw * 2);
    g.restore();
  }

  var DEEP = [], FOAM = [];
  function seedDeep() {
    DEEP = [];
    for (var i = 0; i < 9; i++) DEEP.push({ kind: 'kelp', x: rnd(0, W), y: rnd(0, H * 1.6), h: rnd(70, 150), ph: rnd(0, 6), par: rnd(0.35, 0.55) });
    for (var j = 0; j < 6; j++) DEEP.push({ kind: 'stone', x: rnd(0, W), y: rnd(0, H * 1.6), r: rnd(20, 50), seed: Math.random() * 10, par: rnd(0.3, 0.45) });
    for (var k = 0; k < 3; k++) DEEP.push({ kind: 'fish', x: rnd(0, W), y: rnd(0, H * 1.6), n: Math.floor(rnd(10, 18)), dir: Math.random() < 0.5 ? -1 : 1, ph: rnd(0, 6), par: rnd(0.45, 0.6) });
    FOAM = [];
    for (var f = 0; f < 7; f++) FOAM.push({ x: rnd(0, W), y: rnd(-H, H), r: rnd(10, 26), seed: Math.random() * 10, rot: rnd(0, 6) });
  }
  function drawDeep() {
    var t = diff(), vis = 0.5 - t * 0.3;
    if (vis <= 0.05) return;
    g.save(); g.globalAlpha = vis;
    DEEP.forEach(function (o) {
      var span = H * 1.6, y = ((o.y + travel * o.par) % span + span) % span - H * 0.3;
      if (o.kind === 'kelp') {
        g.strokeStyle = 'rgba(6,28,26,.9)'; g.lineWidth = 6; g.lineCap = 'round';
        for (var b = 0; b < 3; b++) {
          var bx = o.x + b * 7 - 7;
          g.beginPath(); g.moveTo(bx, y + o.h);
          g.bezierCurveTo(bx + Math.sin(time * 0.02 + o.ph + b) * 14, y + o.h * 0.6, bx - Math.sin(time * 0.025 + o.ph) * 12, y + o.h * 0.3, bx + Math.sin(time * 0.03 + o.ph + b) * 10, y);
          g.stroke();
        }
      } else if (o.kind === 'stone') {
        g.fillStyle = 'rgba(4,18,20,.85)';
        g.beginPath();
        for (var i = 0; i <= 10; i++) { var a = i / 10 * Math.PI * 2, rr = o.r * (0.75 + Math.abs(Math.sin(o.seed * 5 + i * 1.9)) * 0.35); if (i === 0) g.moveTo(o.x + Math.cos(a) * rr, y + Math.sin(a) * rr * 0.7); else g.lineTo(o.x + Math.cos(a) * rr, y + Math.sin(a) * rr * 0.7); }
        g.closePath(); g.fill();
      } else {
        o.ph += 0.02;
        g.fillStyle = 'rgba(2,10,12,.95)';
        for (var f = 0; f < o.n; f++) {
          var fx0 = ((o.x + o.dir * time * 0.3 + Math.cos(f * 2.3 + o.ph) * (18 + f * 3)) % (W + 80) + W + 80) % (W + 80) - 40;
          var fy0 = y + Math.sin(f * 1.6 + o.ph) * (12 + f * 2);
          g.save(); g.translate(fx0, fy0); if (o.dir < 0) g.scale(-1, 1);
          g.beginPath(); g.ellipse(0, 0, 6, 2, 0, 0, Math.PI * 2); g.fill();
          g.beginPath(); g.moveTo(-5, 0); g.lineTo(-8.5, -2.4); g.lineTo(-8.5, 2.4); g.fill();
          g.restore();
        }
      }
    });
    g.restore();
    // voile d'eau par-dessus le fond : plus c'est profond, plus c'est flou et bleu
    g.fillStyle = 'rgba(16,52,58,' + (0.35 + t * 0.25).toFixed(2) + ')'; g.fillRect(0, 0, W, H);
  }
  function drawFoam() {
    FOAM.forEach(function (f) {
      f.y += speed; 
      var y = f.y;
      if (y > H + 40) { f.y = -rnd(40, 200); f.x = rnd(0, W); }
      g.save(); g.translate(f.x, y); g.rotate(f.rot);
      for (var i = 0; i < 9; i++) {
        var a = f.seed + i * 0.7, rr = f.r * (0.4 + Math.abs(Math.sin(f.seed * 3 + i)) * 0.6);
        g.fillStyle = 'rgba(225,245,248,' + (0.08 + Math.abs(Math.sin(a * 2)) * 0.12).toFixed(2) + ')';
        g.beginPath(); g.ellipse(Math.cos(a) * f.r * 0.6, Math.sin(a) * f.r * 0.4, rr * 0.5, rr * 0.25, a, 0, Math.PI * 2); g.fill();
      }
      g.restore();
    });
  }
  function drawGlint() {
    if (reduce) return;
    var t = diff(), a = 0.5 - t * 0.45;
    if (a <= 0.05) return;
    g.save(); g.globalCompositeOperation = 'lighter';
    for (var i = 0; i < 26; i++) {
      var bx = W * 0.15 + i * 9 + Math.sin(time * 0.03 + i) * 10, by = H * 0.08 + i * 7 + ((time * 0.6 + i * 23) % 40);
      var tw = Math.max(0, Math.sin(time * 0.15 + i * 1.7));
      if (tw < 0.4) continue;
      g.fillStyle = 'rgba(255,240,210,' + (a * tw * 0.7).toFixed(2) + ')';
      g.beginPath(); g.ellipse(bx, by, 3 + tw * 3, 0.9, -0.5, 0, Math.PI * 2); g.fill();
    }
    g.restore();
  }

  function drawWater() {
    var t = diff();
    var bg = g.createRadialGradient(P.x, P.y, 20, W / 2, H * 0.55, H * 0.85);
    bg.addColorStop(0, 'rgb(' + Math.round(40 - t * 14) + ',' + Math.round(86 - t * 34) + ',' + Math.round(94 - t * 36) + ')');
    bg.addColorStop(0.5, 'rgb(' + Math.round(20 - t * 8) + ',' + Math.round(54 - t * 22) + ',' + Math.round(62 - t * 24) + ')');
    bg.addColorStop(1, 'rgb(' + Math.round(6 - t * 3) + ',' + Math.round(22 - t * 10) + ',' + Math.round(28 - t * 12) + ')');
    g.fillStyle = bg; g.fillRect(0, 0, W, H);
    drawDeep();

    if (TEX.pNoise) {
      tile(TEX.pNoise, Math.sin(time * 0.004) * 60, -travel * 0.6, 1.6, 0.22, 'overlay');
      tile(TEX.pNoise, 80 + Math.cos(time * 0.003) * 40, -travel * 0.85 + 200, 1, 0.14, 'overlay');
      if (!reduce) {
        tile(TEX.pCaus, time * 0.25, -travel * 0.7, 1.15, 0.13 - t * 0.06, 'lighter');
        tile(TEX.pCaus, -time * 0.18 + 90, -travel * 0.7 + 60, 1.6, 0.09 - t * 0.04, 'lighter');
      }
    }

    // lueur chaude de la cover
    var warm = g.createRadialGradient(P.x + 24, P.y + 8, 10, P.x + 24, P.y + 8, 170);
    warm.addColorStop(0, 'rgba(170,64,28,' + (0.32 + t * 0.08).toFixed(2) + ')'); warm.addColorStop(1, 'rgba(170,64,28,0)');
    g.save(); g.globalCompositeOperation = 'screen'; g.fillStyle = warm; g.fillRect(0, 0, W, H); g.restore();

    // reflets du ciel
    specks.forEach(function (s) {
      var a = 0.25 + Math.sin(s.a) * 0.25;
      if (a <= 0.05) return;
      g.fillStyle = 'rgba(220,245,248,' + a.toFixed(2) + ')';
      g.beginPath(); g.ellipse(s.x, s.y, 2.6 + s.s * 2, 0.8, -0.3, 0, Math.PI * 2); g.fill();
    });

    drawFoam();
    drawGlint();

    // courants : traînées d'écume qui filent sur le côté
    flows.forEach(function (fl) {
      g.save(); g.beginPath(); g.rect(0, fl.y, W, fl.h); g.clip();
      var cg = g.createLinearGradient(0, fl.y, 0, fl.y + fl.h);
      cg.addColorStop(0, 'rgba(120,200,210,0)'); cg.addColorStop(0.5, 'rgba(120,200,210,.12)'); cg.addColorStop(1, 'rgba(120,200,210,0)');
      g.fillStyle = cg; g.fillRect(0, fl.y, W, fl.h);
      g.strokeStyle = 'rgba(220,245,248,.35)'; g.lineWidth = 1.2;
      for (var i = 0; i < 12; i++) {
        var yy = fl.y + 10 + (i * 37) % (fl.h - 20), xx = ((i * 83 + time * 3 * fl.dir) % (W + 120) + W + 120) % (W + 120) - 60;
        g.beginPath(); g.moveTo(xx, yy); g.quadraticCurveTo(xx + 20 * fl.dir, yy - 3, xx + 46 * fl.dir, yy); g.stroke();
      }
      g.fillStyle = 'rgba(220,245,248,.5)'; g.font = '500 11px "IBM Plex Mono", monospace'; g.textAlign = fl.dir > 0 ? 'left' : 'right';
      g.fillText(fl.dir > 0 ? 'COURANT →' : '← COURANT', fl.dir > 0 ? 10 : W - 10, fl.y + 14);
      g.restore();
    });

    // ondes : anneau clair + anneau sombre, comme sur une vraie surface
    ripples.forEach(function (r) {
      var a = r.life * (r.c ? 0.7 : 0.4);
      g.lineWidth = 1.6;
      g.strokeStyle = r.c ? 'rgba(255,120,60,' + a.toFixed(2) + ')' : 'rgba(210,240,245,' + a.toFixed(2) + ')';
      g.beginPath(); g.ellipse(r.x, r.y, r.r * 1.12, r.r, 0, 0, Math.PI * 2); g.stroke();
      g.strokeStyle = 'rgba(0,10,14,' + (a * 0.6).toFixed(2) + ')';
      g.beginPath(); g.ellipse(r.x, r.y, r.r * 1.12 + 2.5, r.r + 2.2, 0, 0, Math.PI * 2); g.stroke();
    });
  }

  function rockPath(o, grow) {
    g.beginPath();
    for (var i = 0; i <= 14; i++) {
      var a = i / 14 * Math.PI * 2 + o.rot, rr = (o.r + (grow || 0)) * (0.8 + Math.abs(Math.sin(o.seed * 7 + i * 1.7)) * 0.28);
      var x = o.x + Math.cos(a) * rr, y = o.y + Math.sin(a) * rr * 0.88;
      if (i === 0) g.moveTo(x, y); else g.lineTo(x, y);
    }
    g.closePath();
  }

  function drawRock(o) {
    var ug = g.createRadialGradient(o.x, o.y + 6, o.r * 0.6, o.x, o.y + 6, o.r * 2);
    ug.addColorStop(0, 'rgba(4,16,18,.55)'); ug.addColorStop(1, 'rgba(4,16,18,0)');
    g.fillStyle = ug; g.beginPath(); g.ellipse(o.x, o.y + 6, o.r * 2, o.r * 1.7, 0, 0, Math.PI * 2); g.fill();
    // sillage d'écume en V vers l'aval
    g.strokeStyle = 'rgba(225,245,248,.28)'; g.lineWidth = 2;
    for (var k = 0; k < 3; k++) {
      var sp = o.r * (0.6 + k * 0.25), ln = o.r * (1.4 + k * 0.6);
      g.beginPath(); g.moveTo(o.x - sp, o.y + o.r * 0.5); g.quadraticCurveTo(o.x - sp * 1.3, o.y + ln * 0.7, o.x - sp * 1.6, o.y + ln);
      g.moveTo(o.x + sp, o.y + o.r * 0.5); g.quadraticCurveTo(o.x + sp * 1.3, o.y + ln * 0.7, o.x + sp * 1.6, o.y + ln); g.stroke();
    }
    // ombre portée dans l'eau
    g.save(); g.translate(5, 7); g.fillStyle = 'rgba(0,8,12,.35)'; rockPath(o, 2); g.fill(); g.restore();
    // pierre texturée
    var rg = g.createRadialGradient(o.x - o.r * 0.35, o.y - o.r * 0.45, 2, o.x, o.y, o.r * 1.2);
    rg.addColorStop(0, '#5E6B6A'); rg.addColorStop(0.55, '#2C3836'); rg.addColorStop(1, '#111917');
    g.fillStyle = rg; rockPath(o); g.fill();
    if (TEX.pStone) { g.save(); rockPath(o); g.clip(); g.globalAlpha = 0.35; g.globalCompositeOperation = 'overlay'; g.fillStyle = TEX.pStone; g.translate(o.seed * 30, o.y * 0.2); g.fillRect(-W, -H, W * 3, H * 3); g.restore(); }
    // reflet mouillé
    g.fillStyle = 'rgba(230,248,250,.28)';
    g.beginPath(); g.ellipse(o.x - o.r * 0.3, o.y - o.r * 0.42, o.r * 0.35, o.r * 0.12, -0.5, 0, Math.PI * 2); g.fill();
    // collier d'écume qui respire
    g.strokeStyle = 'rgba(235,250,252,' + (0.55 + Math.sin(time * 0.1 + o.seed) * 0.15).toFixed(2) + ')';
    g.lineWidth = 2.4; g.setLineDash([5, 4]); rockPath(o, 4 + Math.sin(time * 0.08 + o.seed) * 1.5); g.stroke(); g.setLineDash([]);
  }

  function drawLog(o) {
    g.save(); g.translate(o.x, o.y); g.rotate(o.rot);
    g.fillStyle = 'rgba(0,8,12,.35)'; g.fillRect(-o.len / 2 + 5, -7, o.len, 20);
    var lg = g.createLinearGradient(0, -10, 0, 10);
    lg.addColorStop(0, '#7A5636'); lg.addColorStop(0.45, '#4E3420'); lg.addColorStop(1, '#22160C');
    g.fillStyle = lg;
    g.beginPath(); g.moveTo(-o.len / 2, -8); g.lineTo(o.len / 2, -10); g.lineTo(o.len / 2, 10); g.lineTo(-o.len / 2, 8); g.closePath(); g.fill();
    g.strokeStyle = 'rgba(20,12,6,.55)'; g.lineWidth = 1;
    for (var l = -o.len / 2 + 6; l < o.len / 2 - 4; l += 9) { g.beginPath(); g.moveTo(l, -8 + Math.sin(l + o.seed) * 1.5); g.lineTo(l + 12, -2 + Math.sin(l * 0.7) * 2); g.stroke(); g.beginPath(); g.moveTo(l + 4, 3); g.lineTo(l + 14, 8); g.stroke(); }
    g.fillStyle = 'rgba(70,110,60,.55)'; g.beginPath(); g.ellipse(-o.len * 0.15, 4, o.len * 0.14, 3, 0, 0, Math.PI * 2); g.fill();
    g.fillStyle = '#B8915F'; g.beginPath(); g.ellipse(o.len / 2, 0, 4, 10, 0, 0, Math.PI * 2); g.fill();
    g.strokeStyle = '#7A5636'; g.lineWidth = 1; g.beginPath(); g.ellipse(o.len / 2, 0, 2, 6, 0, 0, Math.PI * 2); g.stroke();
    g.fillStyle = 'rgba(235,245,240,.18)'; g.fillRect(-o.len / 2 + 4, -7, o.len - 10, 2);
    g.strokeStyle = 'rgba(235,250,252,.45)'; g.lineWidth = 2; g.setLineDash([4, 5]);
    g.beginPath(); g.ellipse(0, 0, o.len / 2 + 6, 15, 0, 0, Math.PI * 2); g.stroke(); g.setLineDash([]);
    g.restore();
  }

  function drawPool(o) {
    g.save(); g.translate(o.x, o.y);
    var pg = g.createRadialGradient(0, 0, 2, 0, 0, o.r * 1.5);
    pg.addColorStop(0, 'rgba(0,3,6,1)'); pg.addColorStop(0.25, 'rgba(2,12,16,.9)'); pg.addColorStop(0.7, 'rgba(8,30,36,.4)'); pg.addColorStop(1, 'rgba(8,30,36,0)');
    g.fillStyle = pg; g.beginPath(); g.arc(0, 0, o.r * 1.5, 0, Math.PI * 2); g.fill();
    // bras d'écume en spirale
    for (var arm = 0; arm < 4; arm++) {
      g.beginPath();
      for (var s = 0; s <= 40; s++) {
        var tt = s / 40, rad = o.r * (1.45 - tt * 1.3), ang = o.ph * 2.2 + arm * Math.PI / 2 + tt * 5.2;
        var x = Math.cos(ang) * rad, y = Math.sin(ang) * rad * 0.92;
        if (s === 0) g.moveTo(x, y); else g.lineTo(x, y);
      }
      g.strokeStyle = arm % 2 ? 'rgba(255,110,50,.35)' : 'rgba(215,242,246,.55)';
      g.lineWidth = 2.2; g.stroke();
    }
    g.fillStyle = 'rgba(0,0,0,.85)'; g.beginPath(); g.arc(0, 0, o.r * 0.22, 0, Math.PI * 2); g.fill();
    g.restore();
  }

  function drawShoal(o) {
    g.save(); g.globalAlpha = 0.5;
    for (var f = 0; f < o.n; f++) {
      var fx0 = o.x + Math.cos(f * 2.4 + o.ph) * (14 + f * 3), fy0 = o.y + Math.sin(f * 1.7 + o.ph) * (10 + f * 2);
      g.save(); g.translate(fx0, fy0); g.rotate(o.dir > 0 ? Math.sin(o.ph * 3 + f) * 0.15 : Math.PI + Math.sin(o.ph * 3 + f) * 0.15);
      g.fillStyle = '#03090C';
      g.beginPath(); g.ellipse(0, 0, 8, 2.6, 0, 0, Math.PI * 2); g.fill();
      g.beginPath(); g.moveTo(-7, 0); g.lineTo(-11, -3 + Math.sin(o.ph * 6 + f) * 1.5); g.lineTo(-11, 3 + Math.sin(o.ph * 6 + f) * 1.5); g.fill();
      g.restore();
    }
    g.restore();
  }

  function drawItems() {
    items.forEach(function (it) {
      if (it.kind === 'air') {
        var r = 13 + Math.sin(it.ph) * 1.2;
        var bg2 = g.createRadialGradient(it.x - 4, it.y - 5, 1, it.x, it.y, r);
        bg2.addColorStop(0, 'rgba(255,255,255,.75)'); bg2.addColorStop(0.35, 'rgba(170,230,240,.25)'); bg2.addColorStop(1, 'rgba(120,200,215,.08)');
        g.fillStyle = bg2; g.beginPath(); g.arc(it.x, it.y, r, 0, Math.PI * 2); g.fill();
        g.strokeStyle = 'rgba(220,250,255,.85)'; g.lineWidth = 1.5; g.stroke();
        return;
      }
      var fl = 0.65 + Math.sin(it.ph * 1.7) * 0.35;
      g.save(); g.globalCompositeOperation = 'lighter';
      var eg = g.createRadialGradient(it.x, it.y, 0, it.x, it.y, 20);
      eg.addColorStop(0, 'rgba(255,180,100,' + (0.75 * fl).toFixed(2) + ')'); eg.addColorStop(0.4, 'rgba(255,100,40,' + (0.35 * fl).toFixed(2) + ')'); eg.addColorStop(1, 'rgba(255,80,30,0)');
      g.fillStyle = eg; g.beginPath(); g.arc(it.x, it.y, 20, 0, Math.PI * 2); g.fill();
      g.fillStyle = 'rgba(255,230,190,.95)'; g.beginPath(); g.arc(it.x, it.y, 2.4, 0, Math.PI * 2); g.fill();
      for (var k = 0; k < 4; k++) { var a = it.ph * 0.8 + k * 1.6, rr = 6 + Math.sin(it.ph + k) * 3; g.fillStyle = 'rgba(255,120,50,.8)'; g.fillRect(it.x + Math.cos(a) * rr, it.y + Math.sin(a) * rr, 1.6, 1.6); }
      g.restore();
      // reflet de la braise dans l'eau
      g.fillStyle = 'rgba(255,110,50,.12)'; g.beginPath(); g.ellipse(it.x, it.y + 10, 8, 3, 0, 0, Math.PI * 2); g.fill();
    });
  }

  /* ---------- Toi, vu du dessus : rendu haute définition pré-calculé ---------- */
  var SPR = { frames: [], n: 16, s: 3, w: 124, h: 140 };
  function limbC(c, x1, y1, cx, cy, x2, y2, w, c1, c2, shade) {
    var lg = c.createLinearGradient(x1, y1 - w, x1 + w * 0.3, y1 + w);
    lg.addColorStop(0, c1); lg.addColorStop(1, c2);
    c.strokeStyle = lg; c.lineWidth = w; c.lineCap = 'round';
    c.beginPath(); c.moveTo(x1, y1); c.quadraticCurveTo(cx, cy, x2, y2); c.stroke();
    if (shade) { c.strokeStyle = 'rgba(255,255,255,.16)'; c.lineWidth = w * 0.25; c.beginPath(); c.moveTo(x1, y1 - w * 0.25); c.quadraticCurveTo(cx, cy - w * 0.25, x2, y2 - w * 0.25); c.stroke(); }
  }
  function drawBody(c, w, w2, o) {
    o = o || OUTFITS.cover;
    c.lineCap = 'round'; c.lineJoin = 'round';
    limbC(c, -5, 12, -15, 24 + w2, -8, 31, 10.5, '#2C2F33', '#0A0B0C', true);
    limbC(c, -8, 31, -6, 36, -4, 40 + w2, 9.8, '#2C2F33', '#0A0B0C', true);
    limbC(c, 5, 12, 9, 26, 10, 41 - w2, 10.5, '#30333A', '#0A0B0C', true);
    c.strokeStyle = 'rgba(205,42,30,.95)'; c.lineWidth = 1.3;
    c.beginPath(); c.moveTo(-9.5, 13); c.quadraticCurveTo(-19.5, 24 + w2, -12.5, 31); c.quadraticCurveTo(-10, 36, -8.5, 40 + w2); c.stroke();
    c.beginPath(); c.moveTo(9.5, 13); c.quadraticCurveTo(13.5, 26, 14.6, 40 - w2); c.stroke();
    function shoe(x, y, rot) {
      c.save(); c.translate(x, y); c.rotate(rot);
      c.fillStyle = 'rgba(0,0,0,.25)'; c.beginPath(); c.ellipse(1, 2, 5.8, 8, 0, 0, Math.PI * 2); c.fill();
      c.fillStyle = '#CFCFCB'; c.beginPath(); c.ellipse(0, 1, 5.4, 7.8, 0, 0, Math.PI * 2); c.fill();
      var sg = c.createLinearGradient(-4, -6, 4, 6); sg.addColorStop(0, '#FFFFFF'); sg.addColorStop(1, '#DCDCD8');
      c.fillStyle = sg; c.beginPath(); c.ellipse(0, -0.3, 4.6, 6.8, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = 'rgba(0,0,0,.2)'; c.lineWidth = 0.6;
      for (var l = -3; l <= 1; l += 1.4) { c.beginPath(); c.moveTo(-1.8, l); c.lineTo(1.8, l); c.stroke(); }
      c.restore();
    }
    shoe(-4, 44 + w2, -0.1); shoe(10.5, 46 - w2, 0.18);
    // bras : manches longues, ou manches courtes avec avant-bras nus
    if (o.short) {
      limbC(c, -9, -12, -23, -10 + w * 2.5, -35, -6 + w * 3.5, 7.6, '#C99474', '#8A5A40', true);
      limbC(c, 9, -12, 23, -10 - w * 2.5, 35, -6 - w * 3.5, 7.6, '#C99474', '#8A5A40', true);
      limbC(c, -9, -12, -14, -12 + w, -19, -10 + w * 1.4, 10, o.sleeve[0], o.sleeve[1], true);
      limbC(c, 9, -12, 14, -12 - w, 19, -10 - w * 1.4, 10, o.sleeve[0], o.sleeve[1], true);
    } else {
      limbC(c, -9, -12, -23, -10 + w * 2.5, -35, -6 + w * 3.5, 9, o.sleeve[0], o.sleeve[1], true);
      limbC(c, 9, -12, 23, -10 - w * 2.5, 35, -6 - w * 3.5, 9, o.sleeve[0], o.sleeve[1], true);
      c.strokeStyle = '#111'; c.lineWidth = 4.2;
      c.beginPath(); c.moveTo(-33, -6.2 + w * 3.4); c.lineTo(-36.6, -5.6 + w * 3.5); c.stroke();
      c.beginPath(); c.moveTo(33, -6.2 - w * 3.4); c.lineTo(36.6, -5.6 - w * 3.5); c.stroke();
    }
    function hand(x, y, rot) {
      c.save(); c.translate(x, y); c.rotate(rot);
      var hg = c.createRadialGradient(-1, -1, 0, 0, 0, 5); hg.addColorStop(0, '#C99474'); hg.addColorStop(1, '#8A5A40');
      c.fillStyle = hg; c.beginPath(); c.ellipse(0, 0, 4.4, 3.5, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = '#8A5A40'; c.lineWidth = 1.5;
      for (var f = -1.5; f <= 1.5; f += 1) { c.beginPath(); c.moveTo(3, f); c.lineTo(5.6, f * 1.3); c.stroke(); }
      c.restore();
    }
    hand(-40.5, -5 + w * 3.5, Math.PI + 0.2); hand(40.5, -5 - w * 3.5, -0.2);
    // haut
    var jg = c.createLinearGradient(-12, -18, 12, 14);
    jg.addColorStop(0, o.body[0]); jg.addColorStop(0.5, o.body[1]); jg.addColorStop(1, o.body[2]);
    c.fillStyle = jg;
    c.beginPath(); c.moveTo(-12, -16); c.quadraticCurveTo(0, -21, 12, -16); c.quadraticCurveTo(13.5, -2, 11, 14); c.lineTo(-11, 14); c.quadraticCurveTo(-13.5, -2, -12, -16); c.closePath(); c.fill();
    if (o.panel) {
      c.fillStyle = o.panel;
      c.beginPath(); c.moveTo(-11, 5); c.lineTo(-3, -3); c.lineTo(0, 1); c.lineTo(3, -3); c.lineTo(11, 5); c.lineTo(11, 14); c.lineTo(-11, 14); c.closePath(); c.fill();
    }
    if (o.chevron) { c.fillStyle = o.chevron; c.beginPath(); c.moveTo(-3, -3); c.lineTo(0, 1); c.lineTo(3, -3); c.lineTo(2, 6); c.lineTo(-2, 6); c.closePath(); c.fill(); }
    if (o.band) { c.fillStyle = o.band; c.fillRect(-9, -10, 18, 2.6); }
    if (o.bandRed) { c.fillStyle = o.bandRed; c.fillRect(-6, -6.4, 12, 1.8); }
    if (o.print) {
      c.save(); c.fillStyle = o.print === 'KANIAR' ? '#FF5B1F' : '#F2EEE6';
      c.font = '900 ' + (o.print.length > 4 ? 5.2 : 6.5) + 'px "Big Shoulders Display", Impact, sans-serif'; c.textAlign = 'center';
      c.fillText(o.print, 0, 3); c.restore();
    }
    c.strokeStyle = 'rgba(0,0,0,.28)'; c.lineWidth = 0.9;
    c.beginPath(); c.moveTo(-8, -14); c.quadraticCurveTo(-4, -6, -9, 2); c.moveTo(7, -14); c.quadraticCurveTo(4, -7, 8, 1); c.stroke();
    var shine = c.createLinearGradient(-10, -16, 2, -6); shine.addColorStop(0, 'rgba(255,255,255,.3)'); shine.addColorStop(1, 'rgba(255,255,255,0)');
    c.fillStyle = shine; c.beginPath(); c.ellipse(-5, -12, 6, 3, -0.4, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#7E5139'; c.fillRect(-3, -21, 6, 4);
    if (o.hood) {
      var hd = c.createRadialGradient(0, -30, 4, 0, -28, 14); hd.addColorStop(0, '#2A2A2A'); hd.addColorStop(1, '#141414');
      c.fillStyle = hd; c.beginPath(); c.ellipse(0, -27, 12.5, 13, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = '#E8E2D6'; c.lineWidth = 1; c.beginPath(); c.moveTo(-3, -17); c.lineTo(-4, -10); c.moveTo(3, -17); c.lineTo(4, -10); c.stroke();
    } else {
      c.strokeStyle = o.short ? 'rgba(0,0,0,.25)' : '#161616'; c.lineWidth = 2; c.beginPath(); c.arc(0, -18, 4.6, 0.12 * Math.PI, 0.88 * Math.PI); c.stroke();
    }
    c.fillStyle = 'rgba(0,10,14,.35)'; c.beginPath(); c.ellipse(0, -34, 12, 8, 0, 0, Math.PI * 2); c.fill();
    var fg = c.createRadialGradient(-2.5, -28, 1, 0, -25, 9.5);
    fg.addColorStop(0, '#D2A084'); fg.addColorStop(0.7, '#A36F51'); fg.addColorStop(1, '#7A4C35');
    c.fillStyle = fg; c.beginPath(); c.ellipse(0, -25.5, 7.4, 8.8, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#0E0A08';
    c.beginPath(); c.ellipse(0, -31.4, 8.8, 5.4, 0, Math.PI, 0); c.fill();
    for (var k = 0; k < 16; k++) {
      var ca = Math.PI + (k / 15) * Math.PI, cr = 8.6 + Math.sin(k * 3.1) * 1.1;
      c.beginPath(); c.arc(Math.cos(ca) * cr * 0.96, -29.5 + Math.sin(ca) * cr * 0.72, 2 + (k % 3) * 0.45, 0, Math.PI * 2); c.fill();
    }
    c.strokeStyle = 'rgba(14,10,8,.9)'; c.lineWidth = 1.2;
    c.beginPath(); c.moveTo(-5, -28.4); c.quadraticCurveTo(-3, -29.2, -1.6, -28.6); c.moveTo(1.6, -28.6); c.quadraticCurveTo(3, -29.2, 5, -28.4); c.stroke();
    c.lineWidth = 0.9;
    c.beginPath(); c.moveTo(-4.6, -26); c.quadraticCurveTo(-3.2, -25.2, -1.8, -26); c.moveTo(1.8, -26); c.quadraticCurveTo(3.2, -25.2, 4.6, -26); c.stroke();
    c.strokeStyle = 'rgba(110,70,50,.75)'; c.lineWidth = 1;
    c.beginPath(); c.moveTo(0, -25); c.lineTo(-0.6, -22.6); c.lineTo(0.8, -22.4); c.stroke();
    c.fillStyle = 'rgba(14,10,8,.75)'; c.beginPath(); c.ellipse(0, -19.8, 2.8, 0.6, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = 'rgba(255,235,220,.3)'; c.beginPath(); c.ellipse(-2.6, -28, 2.4, 1.1, -0.2, 0, Math.PI * 2); c.fill();
  }
  // la photo fait 384 × 440 px ; le torse est au point (193, 135)
  var PH = { w: 384, h: 440, cx: 193, cy: 135, k: 112 / 384 };
  function buildSprites() {
    var im = PHOTO[OUTFITS[SAVE.outfit].photo];
    SPR.frames = [];
    if (!im || !im.width) return;
    var cv = mkCanvas(PH.w, PH.h), c = cv.getContext('2d');
    c.drawImage(im, 0, 0, PH.w, PH.h);
    c.globalCompositeOperation = 'source-atop';
    var im2 = c.createRadialGradient(PH.cx, PH.cy, 70, PH.cx, PH.cy + 30, 230);
    im2.addColorStop(0, 'rgba(30,80,88,0)'); im2.addColorStop(0.6, 'rgba(30,80,88,.12)'); im2.addColorStop(1, 'rgba(18,58,66,.5)');
    c.fillStyle = im2; c.fillRect(0, 0, PH.w, PH.h);
    c.globalCompositeOperation = 'destination-in';
    var mk = c.createRadialGradient(PH.cx, PH.cy + 20, 120, PH.cx, PH.cy + 30, 250);
    mk.addColorStop(0, 'rgba(0,0,0,1)'); mk.addColorStop(1, 'rgba(0,0,0,.6)');
    c.fillStyle = mk; c.fillRect(0, 0, PH.w, PH.h);
    SPR.frames = [cv];
  }

  function drawPlayer() {
    if (P.inv > 0 && Math.floor(P.inv / 6) % 2 === 0 && !sinking && !shield) return;
    var s = sinking ? Math.max(0.12, 1 - sinking / 140) : 1;
    // halo sombre sous le corps (partie immergée)
    var sh = g.createRadialGradient(P.x + 4, P.y + 18, 6, P.x + 4, P.y + 18, 64 * s);
    sh.addColorStop(0, 'rgba(0,8,12,.5)'); sh.addColorStop(1, 'rgba(0,8,12,0)');
    g.fillStyle = sh; g.beginPath(); g.ellipse(P.x + 4, P.y + 18, 56 * s, 70 * s, 0, 0, Math.PI * 2); g.fill();
    // sillage : l'eau qui glisse autour du corps
    if (!sinking && !reduce) {
      g.strokeStyle = 'rgba(225,245,248,.22)'; g.lineWidth = 1.6;
      for (var k = 0; k < 3; k++) {
        var off = (time * 1.2 + k * 14) % 42;
        g.beginPath(); g.moveTo(P.x - 30 - k * 4, P.y + 18 + off); g.quadraticCurveTo(P.x - 36 - k * 6, P.y + 40 + off, P.x - 40 - k * 10, P.y + 70 + off * 0.6);
        g.moveTo(P.x + 30 + k * 4, P.y + 18 + off); g.quadraticCurveTo(P.x + 36 + k * 6, P.y + 40 + off, P.x + 40 + k * 10, P.y + 70 + off * 0.6); g.stroke();
      }
    }
    if (SAVE.trail !== 'none' && !sinking && !reduce && Math.random() < 0.6) {
      fx.push({ kind: SAVE.trail === 'bulles' ? 'gold' : 'ember', x: P.x + rnd(-10, 10), y: P.y + 30 + rnd(0, 10), vx: rnd(-0.4, 0.4), vy: rnd(0.2, 0.8), life: 1, r: rnd(1.5, 3.5) });
    }
    var fr = SPR.frames[0];
    var breathe = 1 + Math.sin(time * 0.05) * 0.012, sway = Math.sin(time * 0.025) * 0.035;
    g.save(); g.translate(P.x, P.y); g.rotate(P.rot + sway); g.scale(s * breathe, s * breathe);
    if (sinking) g.globalAlpha = Math.max(0, 1 - sinking / 130);
    if (fr) g.drawImage(fr, -PH.cx * PH.k, -PH.cy * PH.k, PH.w * PH.k, PH.h * PH.k);
    g.restore();
    g.globalAlpha = 1;
    // ondes au contact des mains, des pieds et de la tête
    if (!sinking && !reduce) {
      var w = Math.sin(time * 0.12 / SPR.n * Math.PI * 2 * SPR.n / (Math.PI * 2) * Math.PI * 2 / SPR.n);
      g.lineWidth = 1;
      [[-50, 4], [47, 6], [19, 78], [-1, -30], [-18, 41]].forEach(function (p, i) {
        var cs = Math.cos(P.rot), sn = Math.sin(P.rot), x = P.x + p[0] * cs - p[1] * sn, y = P.y + p[0] * sn + p[1] * cs;
        for (var j = 0; j < 2; j++) {
          var ph = ((time * 0.4 + i * 9 + j * 8) % 16) / 16, rr = 4 + ph * 12;
          g.strokeStyle = 'rgba(220,245,248,' + ((1 - ph) * 0.35).toFixed(2) + ')';
          g.beginPath(); g.ellipse(x, y, rr * 1.1, rr * 0.9, 0, 0, Math.PI * 2); g.stroke();
        }
      });
    }
    if (shield && !sinking) {
      var r = 52 + Math.sin(time * 0.08) * 2;
      var sg = g.createRadialGradient(P.x - 16, P.y - 20, 4, P.x, P.y, r);
      sg.addColorStop(0, 'rgba(255,255,255,.22)'); sg.addColorStop(0.7, 'rgba(160,225,235,.05)'); sg.addColorStop(1, 'rgba(160,225,235,.25)');
      g.fillStyle = sg; g.beginPath(); g.arc(P.x, P.y, r, 0, Math.PI * 2); g.fill();
      g.strokeStyle = 'rgba(210,245,250,.65)'; g.lineWidth = 1.4; g.stroke();
      g.strokeStyle = 'rgba(255,255,255,.6)'; g.lineWidth = 2; g.beginPath(); g.arc(P.x, P.y, r - 6, -2.4, -1.7); g.stroke();
    }
  }

  function drawJoystick() {
    if (!joy.on) return;
    var dx = joy.x - joy.bx, dy = joy.y - joy.by, len = Math.hypot(dx, dy), k = len > 48 ? 48 / len : 1;
    g.save();
    g.fillStyle = 'rgba(7,26,31,.35)'; g.strokeStyle = 'rgba(242,238,230,.45)'; g.lineWidth = 2;
    g.beginPath(); g.arc(joy.bx, joy.by, 52, 0, Math.PI * 2); g.fill(); g.stroke();
    g.fillStyle = 'rgba(255,106,43,.9)'; g.beginPath(); g.arc(joy.bx + dx * k, joy.by + dy * k, 22, 0, Math.PI * 2); g.fill();
    g.restore();
  }

  function draw() {
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (shake > 0 && !reduce) g.translate(rnd(-3, 3), rnd(-3, 3));
    drawWater();
    obs.forEach(function (o) { if (o.kind === 'shoal') drawShoal(o); });
    obs.forEach(function (o) { if (o.kind === 'pool') drawPool(o); });
    drawItems();
    obs.forEach(function (o) { if (o.kind === 'rock') drawRock(o); else if (o.kind === 'log') drawLog(o); });
    drawPlayer();
    fx.forEach(function (p) {
      g.globalAlpha = Math.max(0, p.life);
      if (p.kind === 'ember') { g.fillStyle = '#FF8A4D'; g.fillRect(p.x, p.y, 2.2, 2.2); }
      else if (p.kind === 'drop') { g.fillStyle = '#E6FAFD'; g.fillRect(p.x, p.y, 2, 2); }
      else if (p.kind === 'gold') { g.strokeStyle = '#FFD27A'; g.lineWidth = 1.2; g.beginPath(); g.arc(p.x, p.y, p.r, 0, Math.PI * 2); g.stroke(); g.fillStyle = 'rgba(255,240,200,.8)'; g.fillRect(p.x - p.r * 0.4, p.y - p.r * 0.5, 1.2, 1.2); }
      else { g.strokeStyle = '#CFEFF2'; g.lineWidth = 1; g.beginPath(); g.arc(p.x, p.y, p.r, 0, Math.PI * 2); g.stroke(); }
    });
    g.globalAlpha = 1;
    g.textAlign = 'center'; g.font = '900 20px "Big Shoulders Display", Impact, sans-serif';
    texts.forEach(function (t) { g.globalAlpha = Math.max(0, t.life); g.fillStyle = '#FF6A2B'; g.fillText(t.txt, t.x, t.y); });
    g.globalAlpha = 1;
    g.save(); g.globalCompositeOperation = 'soft-light';
    var cg = g.createLinearGradient(0, 0, 0, H);
    cg.addColorStop(0, 'rgba(40,120,130,.35)'); cg.addColorStop(0.6, 'rgba(255,120,60,.12)'); cg.addColorStop(1, 'rgba(10,40,50,.4)');
    g.fillStyle = cg; g.fillRect(0, 0, W, H); g.restore();
    // halo lumineux autour des étincelles (bloom)
    if (!reduce) { g.save(); g.globalCompositeOperation = 'lighter'; items.forEach(function (it) { if (it.kind !== 'spark') return; var bg3 = g.createRadialGradient(it.x, it.y, 0, it.x, it.y, 46); bg3.addColorStop(0, 'rgba(255,110,50,.16)'); bg3.addColorStop(1, 'rgba(255,110,50,0)'); g.fillStyle = bg3; g.fillRect(it.x - 46, it.y - 46, 92, 92); }); g.restore(); }
    var vg = g.createRadialGradient(W / 2, H * 0.58, H * 0.28, W / 2, H * 0.58, H * 0.8);
    vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,' + (0.5 + diff() * 0.25).toFixed(2) + ')');
    g.fillStyle = vg; g.fillRect(0, 0, W, H);
    if (TEX.pGrain && !reduce) tile(TEX.pGrain, rnd(0, 128), rnd(0, 128), 1, 0.07, 'overlay');
    if (sinking) { g.fillStyle = 'rgba(2,10,14,' + Math.min(0.88, sinking / 130).toFixed(2) + ')'; g.fillRect(0, 0, W, H); }
    drawJoystick();
  }

  function loop(t) {
    if (!running) return;
    var dt = Math.min(2.5, (t - last) / 16.67 || 1); last = t;
    update(dt); if (running) draw();
    requestAnimationFrame(loop);
  }

  function enterFull() {
    stageEl.classList.add('is-full'); document.documentElement.style.overflow = 'hidden';
    $('quit').hidden = false; resize();
  }
  function exitFull() {
    stageEl.classList.remove('is-full'); document.documentElement.style.overflow = '';
    $('quit').hidden = true; resize(); draw();
  }
  function quitGame() {
    running = false; joy.on = false; sinking = 0; fadeOut(0.3);
    $('over').hidden = true; $('shop').hidden = true; $('zone').classList.remove('is-on');
    exitFull(); $('start').hidden = false;
  }
  $('quit').addEventListener('click', quitGame);
  $('quitOver').addEventListener('click', quitGame);
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && stageEl.classList.contains('is-full')) quitGame(); });

  function start() {
    enterFull();
    audioInit(); fadeIn();
    reset();
    $('start').hidden = true; $('over').hidden = true; $('zone').classList.remove('is-on');
    running = true; last = performance.now();
    showZone(0);
    requestAnimationFrame(loop);
  }

  function gameOver() {
    running = false; joy.on = false;
    var s = Math.floor(dist), record = s > best;
    var earned = sparks + nears + (record ? 20 : 0);
    SAVE.wallet += earned; persist(); renderWallet();
    if (ACCOUNT.on && s > 0) fetch('/apps/nans/score', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ jeu: 'ofon', niveau: '', score: s }) }).catch(function () {});
    $('earned').textContent = earned;
    if (record) { best = s; try { localStorage.setItem('nansOfonReal', String(best)); } catch (e) {} }
    $('best').textContent = best;
    $('sDist').textContent = s + ' M';
    $('sSparks').textContent = sparks;
    $('sNear').textContent = nears;
    $('msg').textContent = record && s > 0 ? 'Nouveau record : ' + s + ' m. Poste-le en story avec @nansmerch.' :
      s >= 2400 ? 'Tu as atteint OFON.' : s >= 1500 ? 'Les tourbillons ont eu raison de toi.' : 'Le courant t\'a emporté. Remonte.';
    $('over').hidden = false; $('again').focus();
  }

  function pos(e) {
    var r = canvas.getBoundingClientRect();
    return { x: (e.clientX - r.left) / r.width * W, y: (e.clientY - r.top) / r.height * H };
  }
  canvas.addEventListener('pointerdown', function (e) {
    if (joy.on || !running) return;
    var p = pos(e);
    joy = { on: true, id: e.pointerId, bx: p.x, by: p.y, x: p.x, y: p.y };
    try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    e.preventDefault();
  });
  canvas.addEventListener('pointermove', function (e) {
    if (!joy.on || e.pointerId !== joy.id) return;
    var p = pos(e); joy.x = p.x; joy.y = p.y;
    var dx = joy.x - joy.bx, dy = joy.y - joy.by, len = Math.hypot(dx, dy);
    if (len > 70) { joy.bx = joy.x - dx / len * 70; joy.by = joy.y - dy / len * 70; }
  });
  function release(e) { if (joy.on && e.pointerId === joy.id) joy.on = false; }
  canvas.addEventListener('pointerup', release);
  canvas.addEventListener('pointercancel', release);
  canvas.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  window.addEventListener('keydown', function (e) { if (!running) return; var k = e.key.length === 1 ? e.key.toLowerCase() : e.key; if (/^Arrow/.test(k) || 'zqsdwa'.indexOf(k) >= 0) { keys[k] = true; if (/^Arrow/.test(k)) e.preventDefault(); } });
  window.addEventListener('keyup', function (e) { var k = e.key.length === 1 ? e.key.toLowerCase() : e.key; keys[k] = false; });

  var shopTab = 'outfit', shopFrom = 'start';
  function thumb(key) {
    var cv = document.createElement('canvas'); cv.width = 240; cv.height = 240;
    var c = cv.getContext('2d');
    var im = PHOTO[OUTFITS[shopTab === 'outfit' ? key : SAVE.outfit].photo];
    if (im && im.width) c.drawImage(im, 120 - PH.cx * 0.62, 112 - PH.cy * 0.62, PH.w * 0.62, PH.h * 0.62);
    c.translate(120, 112);
    if (shopTab !== 'outfit') {
      for (var i = 0; i < 14; i++) {
        var x = rnd(-18, 18), y = 70 + i * 4 + rnd(-3, 3), r = rnd(2, 4);
        if (key === 'bulles') { c.strokeStyle = '#FFD27A'; c.lineWidth = 1; c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.stroke(); }
        else if (key === 'braises') { c.fillStyle = 'rgba(255,' + Math.floor(rnd(90, 170)) + ',50,.9)'; c.fillRect(x, y, 2, 2); }
      }
    }
    return cv;
  }
  function renderShop() {
    renderWallet();
    document.querySelectorAll('[data-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.dataset.tab === shopTab ? 'true' : 'false'); });
    var grid = $('shopGrid'); grid.innerHTML = '';
    var cat = shopTab === 'outfit' ? OUTFITS : TRAILS;
    Object.keys(cat).forEach(function (key) {
      var it = cat[key], owned = !!SAVE.owned[key], on = shopTab === 'outfit' ? SAVE.outfit === key : SAVE.trail === key;
      var card = document.createElement('div'); card.className = 'card' + (on ? ' is-on' : '') + (it.price === -1 && !owned ? ' lock' : '');
      card.appendChild(thumb(key));
      var name = document.createElement('b'); name.textContent = it.name; card.appendChild(name);
      var price = document.createElement('span'); price.className = 'price';
      if (owned) { price.textContent = on ? 'PORTÉ' : 'À TOI'; price.classList.add('muted'); }
      else if (it.price === -1) price.textContent = 'EXCLUSIF · AVEC LA VRAIE PIÈCE';
      else price.textContent = it.price + ' ✦';
      card.appendChild(price);
      if (it.price === -1 && !owned) {
        var form = document.createElement('div'); form.className = 'code';
        var input = document.createElement('input'); input.placeholder = 'CODE'; input.setAttribute('aria-label', 'Code ' + it.name); input.autocomplete = 'off';
        var ok = document.createElement('button'); ok.type = 'button'; ok.textContent = 'OK';
        ok.addEventListener('click', function () {
          var code = input.value.trim().toUpperCase();
          if (!/^KAN-[A-Z0-9]{6}$/.test(code)) { toast('Ce code n\'a pas le bon format (ex. KAN-XXXXXX).'); return; }
          ok.disabled = true; toast('Vérification…');
          fetch(OFON_SB.url + '/rest/v1/rpc/utiliser_code', {
            method: 'POST',
            headers: { apikey: OFON_SB.key, 'Content-Type': 'application/json' },
            body: JSON.stringify({ p_code: code })
          }).then(function (r) { return r.ok ? r.json() : null; }).then(function (t) {
            ok.disabled = false;
            if (t === key) { SAVE.owned[key] = 1; persist(); toast('Tenue ' + it.name + ' débloquée.'); renderShop(); }
            else toast('Code invalide ou déjà utilisé.');
          }).catch(function () { ok.disabled = false; toast('Connexion impossible. Réessaie dans un instant.'); });
        });
        form.appendChild(input); form.appendChild(ok); card.appendChild(form);
        var a = document.createElement('a'); a.className = 'link'; a.href = it.url; a.target = '_self'; a.textContent = 'Voir le vrai KANIAR →';
        card.appendChild(a);
      } else {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'btn' + (owned ? ' btn--ghost' : '');
        btn.textContent = owned ? (on ? 'Porté' : 'Porter') : 'Acheter';
        btn.disabled = owned && on;
        btn.addEventListener('click', function () {
          if (!owned) {
            if (SAVE.wallet < it.price) { toast('Il te manque ' + (it.price - SAVE.wallet) + ' ✦. Va en ramasser.'); return; }
            SAVE.wallet -= it.price; SAVE.owned[key] = 1; toast(it.name + ' acheté.');
          }
          if (shopTab === 'outfit') { SAVE.outfit = key; buildSprites(); } else SAVE.trail = key;
          persist(); renderShop();
        });
        card.appendChild(btn);
      }
      grid.appendChild(card);
    });
  }
  function toast(t) { $('toast').textContent = t; }
  function openShop(from) { shopFrom = from; toast(''); renderShop(); $('start').hidden = true; $('over').hidden = true; $('shop').hidden = false; }
  document.querySelectorAll('.js-openshop').forEach(function (b) { b.addEventListener('click', function () { openShop($('over').hidden ? 'start' : 'over'); }); });
  document.querySelectorAll('[data-tab]').forEach(function (t) { t.addEventListener('click', function () { shopTab = t.dataset.tab; renderShop(); }); });
  $('closeshop').addEventListener('click', function () { $('shop').hidden = true; $(shopFrom).hidden = false; renderWallet(); });
  renderWallet();

  $('play').addEventListener('click', start);
  $('again').addEventListener('click', start);
  $('presave').addEventListener('click', function () { this.textContent = 'Bientôt dispo'; });

  reset();
  buildTextures(function () { $('loading').hidden = true; $('play').hidden = false; draw(); });
})();
